import { render, staticRenderFns } from "./ResumoCasamentoDetalhes.vue?vue&type=template&id=21a4399a&"
import script from "./ResumoCasamentoDetalhes.vue?vue&type=script&lang=js&"
export * from "./ResumoCasamentoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ResumoCasamentoDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports